import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Identificá',
  description: 'Reconocé qué querés acompañar en este momento.'
}, {
  number: '02',
  title: 'Elegí',
  description: 'Encontrá una práctica o recurso relacionado.'
}, {
  number: '03',
  title: 'Practicá',
  description: 'Seguí una propuesta breve y posible de adaptar a tu tiempo.'
}, {
  number: '04',
  title: 'Observá',
  description: 'Registrá cómo te sentías antes y qué querés repetir.'
}];
export function MechanismSection() {
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-129" data-mp="103r7oxthcen0">
      <div className="mx-auto max-w-5xl" data-id="element-130" data-mp="vbpr4zpa41r6">
        <div className="mx-auto max-w-2xl text-center" data-id="element-131" data-mp="vaoguxg37jai">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-132" data-mp="rbpbjbqg1kij">
            Un sistema visual para elegir una práctica sin perderte entre{' '}
            <span className="text-aura" data-id="element-133" data-mp="1j2by0nnjrfzl">consejos sueltos</span>.
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-134" data-mp="1j08wp7gy20fk">
            En lugar de guardar rituales, afirmaciones y prácticas aisladas sin saber cuál usar,
            Aura Viva te ayuda a encontrar un punto de partida claro.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-135" data-mp="3u5a2zq0wx9jt">
          {steps.map((step, i) => <motion.article key={step.number} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-2xl border border-lavender bg-card p-6" data-id="element-136" data-mp="2x5z6poeu8pr" data-mpi={i}>
              <span className="font-serif-display text-3xl font-bold leading-none text-gold" data-id="element-137" data-mp="19fko5d07lnr4">
                {step.number}
              </span>
              <h3 className="mt-3 text-base font-bold uppercase tracking-wide text-plum sm:text-lg" data-id="element-138" data-mp="1ed4gthxnm32l">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-plum/75" data-id="element-139" data-mp="17y5koev25s4v">{step.description}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}